import { CircularProgress } from "@mui/material"

interface EmptySectionProps {
    loading: boolean
    message: string
    onClick?: () => void
}

const EmptySection: React.FC<EmptySectionProps> = ({ loading, message, onClick }) => {
    return (
        <div className='h-100 w-100 d-flex align-items-center justify-content-center'>
            {loading && <CircularProgress color='inherit' size={20} />}
            {!loading &&
                <button className='d-flex align-items-center gap-2 bg-transparent border-0 p-0' onClick={onClick}>
                    <i className="fe fe-plus" />
                    <span className="opacity-50">{message}</span>
                </button>
            }
        </div>
    )
}

export default EmptySection